<template>
  <article
    class="FilterAccordian"
    :key="this.title"
  >
    <header class="d-flex justify-content-between align-items-center">
      <h6 class="question-title mb-0">
        No Claim Bonus ({{ this.title}})
      </h6>
      <button @click="cancel()" class="editform-cross border-0 ml-auto bg-transparent"><span style="font-size: 22px;">&times;</span></button>
    </header>
    <transition mode="out-in" name="fadeAndSlide">
      <div class="ncb_outer-container">
        <div class="d-flex align-items-center justify-content-between ncbPercent_container my-2 p-2">
          <p class="mb-0">Made a claim in your current Policy?</p>
          <div class="form-check form-switch my-0 position-relative p-0">
            <label class="form-check-label headinglabel mb-0" for="flexSwitchCheckChecked" >{{ toggleFlag ? 'YES' : 'NO' }}</label>
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              v-model="toggleFlag"   
              @click="toggleFunction()"
            />
          </div>
        </div>
        <h4 class="my-3" v-if="!this.toggleFlag">{{ this.info }}</h4>
        <div>
          <!-- <div class="form-check form-switch my-3 position-relative p-0">
            <label class="form-check-label headinglabel" for="flexSwitchCheckChecked" >{{ toggleFlag ? 'Yes' : 'No' }}</label>
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              v-model="toggleFlag"   
              @click="toggleFunction()"
          
            />
          </div> -->
          <div
            :style="contentStyle"
            class="content"

          >
            <div :style="infoStyle" class="info d-flex align-items-center gap-1 flex-wrap">
              <div v-if="!this.toggleFlag" v-for="(item,index) in this.percentOptions"
              :key="index" class="form-check ncb-percent-container mt-2">
                <input
                  v-if="this.title==='Policy Type'"
                  class="form-check-input"
                  type="checkbox"
                  :id="'checkbox_' + item"
                  :value="item"
                />
                <input
                  v-else-if="this.title === 'NCB'"
                  class="form-check-input"
                  type="radio"
                  :id="'radio_' + item"
                  :value="item"
                  @change="setEligibleNcb"
                  :name=" userData.percentOptions" 
                  v-model="selectedItem"
                />
                <label
                  :for="'radio_' + item"
                  class="form-check-label px-3 py-2"
                >
                  <div class="d-flex align-items-center gap-2">
                    <h5 class="mb-0">{{ item }}</h5>
                  </div>
                </label>
              </div>
              <div v-else class="ncb_eligibility">
                <p class="p-2">No Claim Bonus (NCB) is 0%</p>
                <p class="p-2">Your NCB has been reset to 0% since you filed a claim.</p>
              </div>
            </div>

            <div class="d-flex align-items-center gap-2 mt-4 mb-2 other_ncb_options" v-if="otherNcbOptions.length != 0 && !toggleFlag">
              <h4 class="mb-0" @click="otherNcbHandler()">Other NCB Options</h4>
              <img class="" src="@/assets/images/up-arr-blue.png" width="16" height="16" v-if="!otherNcbOptionsOpen" @click="otherNcbHandler()"/>
              <img class="" src="@/assets/images/down-arr-blue.png" width="16" height="16" v-if="otherNcbOptionsOpen" @click="otherNcbHandler()"/>
            </div>
            <div :style="infoStyle" class="info d-flex align-items-center gap-1 flex-wrap" v-if="!toggleFlag">
            <div v-if="!this.otherNcbOptionsOpen" v-for="(item,index) in this.otherNcbOptions"
              :key="index" class="form-check ncb-percent-container mt-2">
                <input
                  v-if="this.title==='Policy Type'"
                  class="form-check-input"
                  type="checkbox"
                  :id="'checkbox_' + item"
                  :value="item"
                />
                <input
                  v-else-if="this.title === 'NCB'"
                  class="form-check-input"
                  type="radio"
                  :id="'radio_' + item"
                  :value="item"
                  @change="setEligibleNcb"
                  :name=" userData.percentOptions" 
                  v-model="selectedItem"
                />
                <label
                  :for="'radio_' + item"
                  class="form-check-label px-3 py-2"
                >
                  <div class="d-flex align-items-center gap-2">
                    <h5 class="mb-0">{{ item }}</h5>
                  </div>
                </label>
              </div>
            </div>
            <div class="mt-3 ncb_eligibility" v-if="!toggleFlag">
              <p class="p-2" v-html="showEligibileNcb"/>
              <p class="p-2">If the declared NCB % is wrong, insurer may reject your claim.</p>
            </div>
          </div>
          
          <div  class="d-flex gap-4 mt-3 justify-content-end">
            <button class="btn ApplyButton" @click="apply()">Confirm & Proceed</button>
          </div>
        </div>
      </div>
  </transition>
    
  </article>
</template>

<script>
import { ref, computed} from "vue";

export default {
  data() {
    return {
      toggleFlag:null,
      previous_year_claim:null,
      selectedItem:null,
      showEligibileNcb: "",
      odDate:'',
      userData:{},
      percentOptions:[],
      otherNcbOptionsOpen: true,
      otherNcbOptions: [],
    };
  },
  name: "FilterAccordian",
  props: {
    title:  {
      type: String,
      required: true,
    },
    info:  {
      type: String,
      required: true,
    },
  },
  mounted(){
    //get User data
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
    this.selectedItem = this.userData.applicablePercentage;
    this.odDate=this.userData.OdDate;
    let isExpInPrev90Days=this.isDateWithinLast90Days(this.odDate)
    // if(isExpInPrev90Days){
    //   this.percentOptions.push(this.userData.percentOptions[0]);
    // }
    // else{
      this.percentOptions=this.userData.percentOptions;
      this.setEligibleNcb();
    // }
    this.previous_year_claim = this.userData.previous_year_claim;
    this.toggleFlag = this.userData.previous_year_claim;

    let allPercentOptions = ['0%', '20%', '25%', '35%', '45%', '50%'];
    this.otherNcbOptions = allPercentOptions.filter(option => !this.percentOptions.map(option => option.trim()).includes(option));
},
methods:{
  otherNcbHandler(){
    this.otherNcbOptionsOpen = !this.otherNcbOptionsOpen;
  },
  setEligibleNcb() {
    let allPercentOptions = ['0%', '20%', '25%', '35%', '45%', '50%'];
    if (allPercentOptions.length === 0) {
      this.showEligibileNcb = "You are eligible for <b>0%</b> NCB in your new policy";
      return;
    }

    const currentIndex = allPercentOptions.indexOf(this.selectedItem.trim());

    if (currentIndex === -1 || currentIndex === allPercentOptions.length - 1) {
      this.showEligibileNcb = `You are eligible for <b>${this.selectedItem}</b> NCB in your new policy`;
    } else {
      // Show the next percentage in the array
      this.showEligibileNcb = `You are eligible for <b>${allPercentOptions[currentIndex + 1]}</b> NCB in your new policy`;
    }
  },
  isDateWithinLast90Days(odDate) {
    const dateToCheck = new Date(odDate);
    if (isNaN(dateToCheck)) return false;
    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);
    return dateToCheck >= ninetyDaysAgo && dateToCheck <= today;
  },
  //Cancel Selected values
  cancel(){
    this.toggleFlag=null
    this.selectedItem = null;
    this.toggleFlag = this.userData.previous_year_claim;
    this.selectedItem = this.userData.applicablePercentage;
    this.$emit('handleIdvClose');
  },
  //Apply Ncb Change
  apply()
  {
    this.userData.applicablePercentage = this.selectedItem;
    this.userData.previous_year_claim = this.toggleFlag;
    sessionStorage.setItem("userData",JSON.stringify(this.userData))
    this.$emit('update:selected-item', this.selectedItem);
    this.$emit('clearCompareList') // Emit event to parent
    this.$emit('handleIdvClose');
  },

  //toggle changed
  toggleFunction(){
    this.toggleFlag = !this.toggleFlag;
    this.selectedItem = '0%';
    this.showEligibileNcb = `You are eligible for <b>20%</b> NCB in your new policy`
    // this.userData.previous_year_claim =  this.toggleFlag 
    if(this.userData.previous_year_claim)
  {
    this.userData.applicablePercentage = 0;
  }
  if(this.toggleFlag==true){
    this.selectedItem = '0%';
  }else{
    // this.selectedItem = this.userData.applicablePercentage;
  }

    
  },
//   onRadioChange(event){
// this.userData.applicablePercentage = this.selectedItem;

//   }
},

  setup() {
    const expanded = ref(true);
    const contentStyle = computed(() => {
      return { "max-height": expanded.value ? "300px" : "0px" };
    });

    const infoStyle = computed(() => ({
      display: expanded.value ? "block" : "none",
    }));

    return { expanded, contentStyle, infoStyle };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/scss/components/filters.scss";
@import "../../assets/scss/components/select-card.scss";
.fadeAndSlide-enter-from,
.fadeAndSlide-leave-to{
  opacity: 0;
}
.fadeAndSlide-enter-active,
.fadeAndSlide-leave-active{
  transition: opacity 0.3s ease-in-out;
}
.ncb_outer-container{
  .other_ncb_options{
    h4, img{
      color: $active !important;
      cursor: pointer;
    }
  }
  .ncbPercent_container{
    border-radius: 6px;
    background-color: $base-dark-text;
    p{
      font-size: 14px;
      color: $base-text;
      opacity: 1;
    }
    .form-switch{
      gap: 0;
      input{
        transform: scale(0.8);
        cursor: pointer;
      }
    }
  }
  h4{
    font-size: 14px !important;
    color: $text-color !important;
    opacity: 0.7 !important;
    font-weight: 600;
  }
  .info{
    .form-check{
      padding-left: 0 !important;
    }
    .form-check-input{
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      visibility: hidden;
    }
    .form-check-label{
      border-radius: 20px;
      border: 1px solid $border-color;
      cursor: pointer;
    }
    .form-check-input:checked+.form-check-label{
      border-color: $main-bg;
      background-color: $base-dark-text;
      div h5{
        font-weight: 800;
        color: $main-bg;
      }
    }
  }
  .ncb_eligibility{
    border-radius: 8px;
    overflow: hidden;
    background-color: $commonColor;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08);
    p{
      opacity: 1;
      font-size: 14px !important;
    }
    p:first-child{
      background-color: #3eff241a !important;
      opacity: 1;
      color: $success;
    }
  }
  .error-text{
    opacity: 1;
    font-size: 16px;
    color: $error-txt !important;
  }
}

.dark {
  .ncb_outer-container {
    h4{
      color: $heading-darkColor !important;
    }
    .other_ncb_options{
      h4{
        color: $main-bg !important;
        cursor: pointer;
      }
    }
    .ncb_eligibility{
    border-radius: 8px;
    overflow: hidden;
    background-color: $cardBgDark;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08);
    color: $text-darkColorTransparent;
    p{
      opacity: 1;
      font-size: 14px !important;
      &:first-child{
        color: green;
      }
    }
    p:first-child{
      background-color:$cardBgDark !important;
      opacity: 1;
      color: $success;
    }
  }
    .error-text{
      color: $error-txt !important;
    }
  }
  .ncb_outer-container .info .form-check-label{
    color: $text-darkColorTransparent;
  }
}
</style>
